import _classPrivateFieldLooseBase from "@babel/runtime/helpers/esm/classPrivateFieldLooseBase";
import _classPrivateFieldLooseKey from "@babel/runtime/helpers/esm/classPrivateFieldLooseKey";
import { Subject } from '../observable/subject';
var _subject = /*#__PURE__*/_classPrivateFieldLooseKey("subject");
export class ObservableMap extends Map {
  constructor(...args) {
    super(...args);
    Object.defineProperty(this, _subject, {
      writable: true,
      value: new Subject()
    });
    this.set = (key, value) => {
      super.set(key, value);
      _classPrivateFieldLooseBase(this, _subject)[_subject].next(this);
      return this;
    };
    this.delete = key => {
      const result = super.delete(key);
      _classPrivateFieldLooseBase(this, _subject)[_subject].next(this);
      return result;
    };
    this.clear = () => {
      super.clear();
      _classPrivateFieldLooseBase(this, _subject)[_subject].next(this);
    };
    this.subscribe = observer => {
      const subscription = _classPrivateFieldLooseBase(this, _subject)[_subject].subscribe(observer);
      return () => subscription.unsubscribe();
    };
  }
}